import { Record, RecordDraft, RecordFinal } from '../types/sharedTypeImpl.ts';


export function recordToDraft(record: Record): RecordDraft {
    return {
        ...structuredClone(record),
        isDraft: true,
    }
}

export function draftToRecord(
    draft: RecordDraft,
    numIssues: number,
    criticalValuesMissing: boolean
): RecordFinal {
    return {
        ...structuredClone(draft),
        isDraft: false,
        numIssues,
        criticalValuesMissing,
    }
}
